import { ProfileTabContainer } from '../../components/ProfileComponents';
import { ProjectPlanSection } from '../../components/ProjectPlanSection';
import { AdminProjectPlan } from '@platform/client/schemas';

export const ProjectPlanTabContent = ({ planData }: { planData?: AdminProjectPlan | null }) => {
  return (
    <ProfileTabContainer>
      {planData ?
        <ProjectPlanSection planData={planData} />
      : <div>No project plan data available.</div>}
    </ProfileTabContainer>
  );
};
